<template>
  <el-checkbox-group
    v-model="selected"
    @change="handleChange"
    style="max-height: 200px; overflow-y: auto"
  >
    <el-checkbox
      :label="parseInt(item.id)"
      :key="item.id"
      :value="parseInt(item.id)"
      v-for="item in lists"
      >{{ item.name }}</el-checkbox
    >
  </el-checkbox-group>
</template>

<script>
import { commodityCategoryList } from '../../service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: {
      type: Array,
      default: [],
    },
  },
  watch: {
    val: function (v) {
      if (v.length == 0) {
        this.selected = []
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: [],
      lists: [],
    }
  },
  created() {
    this.requestCategories()
  },
  methods: {
    async requestCategories() {
      let data = {
        page: 0,
        size: 500,
        status: 1,
      }
      let res = await commodityCategoryList(data)
      this.lists = res.data.list
    },
    handleChange() {
      this.$emit('change', this.selected || [])
    },
  },
}
</script>